export default {
  primary: "#fc7722",
  primary2: "#eb6f21",
};
